export default {
  product: {
    nameRequired: 'Please enter product name',
    priceRequired: 'Please enter product price',
    pricePositive: 'Product price must be greater than 0',
  },
};
